import RelationshipMetadata from "../../RelationshipMetadata";

class EmployeeEmployeeAdminUserGroupRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "EmployeeEmployeeUserGroupRelationshipMetadata";
        this.parentEnterpriseComponent = "Employee";
        this.childEnterpriseComponent = "EmployeeAdminUserGroup";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "UserGroupUSID";
    }
}

export default EmployeeEmployeeAdminUserGroupRelationshipMetadata;